import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable, Signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { SearchService } from '@psu-pennstateit-swe/apis/search';
import { CACHE_REQUEST_MINUTES } from '@psu-pennstateit-swe/utils/browser';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DisplayNameService {
  private searchService = inject(SearchService);

  displayNameResource = (userId: Signal<string>) =>
    rxResource({
      params: () => userId().substring(0, userId().indexOf('_')),
      stream: ({ params: parsedId }) =>
        this.searchService
          .getPersonByUserId(parsedId, { headers: new HttpHeaders({ [CACHE_REQUEST_MINUTES]: '60' }) })
          .pipe(catchError(() => of(null))),
    });
}
